import './list-view.scss';
import React, { useEffect, useRef, useState } from 'react';
import ImageGenerator         from '../image-generator/image-generator';
import { Link, useLocation } from 'react-router-dom';
import { render_object_type } from '../../shared/services/general/configs';
import MovieCard from '../card/movie-card/movie-card';
import SeriesCard from '../card/series-card/series-card';
import Breadcrumb from '../breadcrumb/breadcrumb';
import { useConfigApp } from '../../shared/services/general/app-context';
import { useSeo } from '../../shared/services/general/seoManager';

function ListView ({ data, type }) {
	const [pageName, setPageName] = useState(null);
	const [breadcrumbType, setBreadcrumbType] = useState('');
	const location = useLocation();
	const path = location.pathname;
	const configApp = useConfigApp();
	const [logo, setLog] = useState(null);
	const { setSeoData } = useSeo();
	const [contents, setContents] = useState([])
	useEffect(() => {
		if (configApp?.logo) {
			setLog(require(`../../assets/images/${configApp?.logo}`).default)
		}
	}, [configApp]);


	useEffect(() => {
		if (path.includes('/category/')) {
			const  id = path.split('/category/')[1].split('/')[0];
			setPageName(data?.category?.name)
			setBreadcrumbType({label: 'دسته بندی ها', path: '/category'})
			setContents(data?.contents)
		} else if (path.includes('/genre/')) {
			const id = path.split('/genre/')[1].split('/')[0];
			setPageName(data?.genre?.name)
			setBreadcrumbType({label: 'ژانر ها', path: '/genre'})
			setContents(data?.contents)
		} else if (path.includes('/p/movies')) {
			const id = path.split('/p/movies/')[1].split('/')[0];
			setPageName(getValueById(id, 'catList'));
			setBreadcrumbType({label: 'دسته بندی ها', path: '/category'})
			setContents(data)
		} else if (path.includes('/p/SERIES')) {
			const id = path.split('/p/SERIES/')[1].split('/')[0];
			setPageName(getValueById(id, 'catList'));
			setBreadcrumbType({label: 'دسته بندی ها', path: '/category'})
			setContents(data)
		} else {
			setContents(data)
		}
	},[data])

	useEffect(() => {
		setSeoData({
			title: `${pageName} | ${configApp?.title}`,
			image: window.location.origin + logo,
			description: null,
		});
	}, [pageName, logo, configApp]);


	const getValueById = (id, source = 'catList') => {
		const storedList = JSON.parse(localStorage.getItem(source)) || [];
		const targetItem = storedList.find(item => item.id === id);
		return targetItem ? targetItem.value : null;
	}

	return (
		<>
			{pageName && (
				<div style={{paddingRight: '20px'}}>
					<Breadcrumb
						style={{marginBottom: '-22px'}}
						firstItem={breadcrumbType || undefined}
						currentItem={pageName}
					/>
					<br />
					<h1>{pageName}</h1>
					<br />
				</div>
			)}
			<div className="box-of-items">

				{contents.length > 0 && contents?.map((item, index) => {
					if (type === 'movies' || type === render_object_type.movie) {
						return (
							<MovieCard key={index}
									   data={item} />
						);
					} else if (type === 'series' || type === render_object_type.series) {
						return (
							<SeriesCard key={index}
										data={item} />
						);
					} else if (type === 'shows' || type === render_object_type.show) {
						return (
							<Link key={index}
								  to={`/shows/${item.id}`}
								  className="card">
								<ImageGenerator src={item.image}
												name={item.title} />
								<div className="card-info">
									<span>{item.title}</span>
									<span>{item.director}</span>
								</div>
							</Link>
						);
					}
					return (
						<Link key={index}
							  to={`/t/${item.tagDefinitionName}/${item.id}`}
							  className="card">
							<ImageGenerator src={item.fields.image}
											name={item.value} />
							<div className="card-info">
								<span>{item.value}</span>
								<span>{item.director}</span>
							</div>
						</Link>
					);
				})}
			</div>
		</>
	);
}

export default ListView;
